import { checkClaimsWeb, checkTier, TOrgConfig } from '@eventr/common'
import { StateCreator } from 'zustand'
import { wpApiClient } from '../data/apiClients'
import { enableChat } from '../utils'
import { BoundStore, useBoundStore } from './bound.store'

export interface OrgConfigSlice {
    orgConfig: TOrgConfig
    setOrgConfig: (config: TOrgConfig) => void
    fetchOrgConfig: () => Promise<void>
    checkFeatureEnabled: (feature: string) => boolean
    chatEnabled: boolean
    teamPageEnabled: boolean
}

export const createOrgConfigSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    OrgConfigSlice
> = (set) => ({
    orgConfig: {
        isWizardComplete: false,
        isPremium: false,
        isRocketChatInitialised: false,
        departmentTags: [],
        groupTags: [],
        orgNiceName: '',
        editInAppDisabled: false,
        userInviteDisabled: false,
        adminEditOnly: false,
        disableChat: false,
        disableLocationServices: false,
        enableBookingService: false,
        themes: [],
    },
    setOrgConfig: (config: TOrgConfig) =>
        set(
            { orgConfig: config, chatEnabled: enableChat() },
            false,
            'setOrgConfig'
        ),
    fetchOrgConfig: async () => {
        const config = await wpApiClient.get<TOrgConfig>(
            'itinerary/v1/config',
            { NOT_IN_GUEST: true }
        )
        if (config.status === 'success' && config.data) {
            set({ orgConfig: config.data }, false, 'setOrgConfig')
        }
    },
    checkFeatureEnabled: (feature: string) => {
        const { tier } = useBoundStore.getState()
        return tier ? checkTier(tier, feature) : false
    },
    chatEnabled: false,
    teamPageEnabled: false,
})

setTimeout(async () => {
    useBoundStore.subscribe(
        (state) => state.wpUser,
        (_) => {
            useBoundStore.setState(
                { chatEnabled: enableChat() },
                false,
                'setChatEnabled-wpUser'
            )
        }
    )
    useBoundStore.subscribe(
        (state) => state.userClaims,
        (_) => {
            useBoundStore.setState(
                {
                    teamPageEnabled: checkClaimsWeb(['/'], ['viewTeamPage']),
                    chatEnabled: enableChat(),
                },
                false,
                'setChatEnabled-claims'
            )
        }
    )
}, 100)
